module.exports = __webpack_public_path__ + "static/media/25UNHCR4.24526d6c.jpg";